import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import store from './redux/store';
// import reportWebVitals from './reportWebVitals';

import './styles/tailwind-color-vars.scss';
// import './styles/style.scss';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// Save the Con
const saveStoretoLS = () =>
  localStorage.setItem('tk-template-store', JSON.stringify(store.getState()));
window.addEventListener('beforeunload', saveStoretoLS);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
